import * as types from '../action-types';

type openProps = {
  top: number;
  left: number;
};

export const openActionSidebarSummaryPopover = (data: openProps) =>
  <const>{
    type: types.openActionSidebarSummaryPopover,
    payload: { data },
  };

export const closeActionSidebarSummaryPopover = () => {
  return <const>{
    type: types.closeActionSidebarSummaryPopover,
  };
};

export const checkCloseActionSidebarSummaryPopover = () => (
  dispatch: Function,
  getState: Function,
) => {
  const {
    decision: { actionSidebarSummary },
  } = getState();
  if (actionSidebarSummary.isOpen) {
    dispatch(closeActionSidebarSummaryPopover());
  }
};

export type ActionSidebarSummaryActions = ReturnType<
  | typeof openActionSidebarSummaryPopover
  | typeof closeActionSidebarSummaryPopover
>;
